import React from "react";
import styled from "styled-components";
import { Link } from "../Link";
import { style } from "../style";

const StyledText = styled.span`
  all: unset;

  color: ${style.colors.grey.dark};
  font-size: ${style.vars.fontSize.small};
`;

type Props = {
  "data-testid"?: string;
};

export const VPCNote: React.FC<Props> = (props) => {
  const testId = props["data-testid"] ?? "vpc-note";

  return (
    <StyledText data-testid={testId}>
      All resources created in this datacenter will be members of the same{" "}
      <Link forceExternal type="external" to="https://docs.digitalocean.com/products/networking/vpc/">
        VPC network
      </Link>
      . They can communicate securely over their Private IP addresses.
    </StyledText>
  );
};
